<template>
  <div>
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/Admin' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>信箱列表</el-breadcrumb-item>
    </el-breadcrumb>
    <el-card class="box-card">
		<el-row class="form-row">
			<el-text style="width:100px; text-align: right;">发信人：</el-text>
			<el-col :span="4">
				<el-input placeholder="请输入发信人" style="width:400px;" v-model="subData.createUserId"></el-input>
			</el-col>
		</el-row>
		<el-row class="form-row">
			<el-text style="width:100px; text-align: right;">类别编号：</el-text>
			<el-col :span="4">
				<el-input placeholder="请输入类别编号" style="width:400px;" v-model="subData.categoryId"></el-input>
			</el-col>
		</el-row>
		<el-row class="form-row">
			<el-text style="width:100px; text-align: right;">信件内容：</el-text>
			<el-col :span="4">
				<el-input placeholder="请输入信件内容" style="width:400px;" v-model="subData.msg"></el-input>
			</el-col>
		</el-row>
		<el-row class="form-row">
			<el-text style="width:100px; text-align: right;">状态，0=不显示，1=显示：</el-text>
			<el-col :span="4">
				<el-input placeholder="请输入状态，0=不显示，1=显示" style="width:400px;" v-model="subData.state"></el-input>
			</el-col>
		</el-row>
		<el-row class="form-row">
			<el-text style="width:100px; text-align: right;">发信时间：</el-text>
			<el-col :span="4">
				<el-input placeholder="请输入发信时间" style="width:400px;" v-model="subData.createdTime"></el-input>
			</el-col>
		</el-row>
		<el-row class="form-row">
			<el-text style="width:100px; text-align: right;">图片列表：</el-text>
			<el-col :span="4">
				<el-input placeholder="请输入图片列表" style="width:400px;" v-model="subData.imgs"></el-input>
			</el-col>
		</el-row>
		<el-row class="form-row">
			<el-text style="width:100px; text-align: right;">是否显示学校，0=不显示，1=显示：</el-text>
			<el-col :span="4">
				<el-input placeholder="请输入是否显示学校，0=不显示，1=显示" style="width:400px;" v-model="subData.isShowSchool"></el-input>
			</el-col>
		</el-row>
		<el-row class="form-row">
			<el-text style="width:100px; text-align: right;">消耗邮票：</el-text>
			<el-col :span="4">
				<el-input placeholder="请输入消耗邮票" style="width:400px;" v-model="subData.minusMoneyCount"></el-input>
			</el-col>
		</el-row>

      <el-row class="bt" style="padding:15px 0; padding-left: 100px;">
        <el-button type="primary" @click="submitEvent">确定</el-button>
        <el-button plain type="primary" @click="backEvent">返回</el-button>
      </el-row>
    </el-card>
  </div>
</template>

  
<script>

export default {
  data() {
    return {
      id: this.$route.query.id?this.$route.query.id:0,
      subData:{
		createUserId : '',
		categoryId : '',
		msg : '',
		state : '',
		createdTime : '',
		imgs : '',
		isShowSchool : '',
		minusMoneyCount : '',

      }
    }
  },
  mounted:function(){
    if(this.id>0){
      this.getData()
    }
  },
  methods: {
    backEvent(){
        this.$router.go(-1)
    },
    getData(){
      var ths = this
      ths.$get('/Mails/queryById?id='+ths.id)
      .then(function (res) { 
          if(res.success){
            ths.subData = res.data
          }
      })
      .catch(function (err) {
        console.log(err)
      })    
    },
    submitEvent() {
      const ths = this;

      ths.$post('/Mails/edit?', ths.subData)
        .then(function (res) { 
            alert(res.msg)
            if(res.success){
              ths.$router.push("/Admin/MailsList")
            }
        })
        .catch(function (err) {
          console.log(err)
        })      
      },
   }
}

</script>

<style>
.form-row{
  padding:15px 0; 
}
</style>